import { render, staticRenderFns } from "./Tasks2.vue?vue&type=template&id=5c707f48&scoped=true"
import script from "./Tasks2.vue?vue&type=script&lang=js"
export * from "./Tasks2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c707f48",
  null
  
)

export default component.exports